module.exports = __webpack_public_path__ + "img/收藏3.e500d7be.png";